import { debounce, isUndefined } from 'lodash'
import { useEffect, useRef } from 'react'
import { QueryCache } from 'react-query'

//? Using of object structure for this method parameters is better than current state
const useScrollRestoration = (
  el: HTMLElement | Window | null,
  queryKey: string,
  setter: (val: any) => void,
  cache?: QueryCache,
  bottomOffset?: number,
  elId?: string,
  // Because this is a hook and we can't use it in a conditional statement,
  // we need to use a boolean to determine if we should use the hook or not
  ignore?: boolean,
): void => {
  const scrollRef = useRef<any>(elId ?? 'currentScroll')
  const setScrollRef = (data: string) => {
    scrollRef.current = data
  }

  const func = (e: any): void => {
    let el = e.target
    el = el.scrollHeight ? el : window.document.documentElement

    bottomOffset = isUndefined(bottomOffset) ? 0 : bottomOffset
    if (
      el.scrollHeight - el.scrollTop - (bottomOffset ?? 0) <= el.clientHeight &&
      el.scrollTop > 10 &&
      (!localStorage.getItem(scrollRef.current) ||
        localStorage.getItem(scrollRef.current) == queryKey)
    ) {
      setter((v: any) => v + 1)
      cache?.invalidateQueries(queryKey)
    }
  }

  useEffect(() => {
    if (ignore) return
    setScrollRef(elId ?? 'currentScroll')
    elId = elId || 'container'
    const elem = el || document.getElementById(elId)
    if (elem !== null) {
      elem.addEventListener('scroll', debounce(func, 100), { capture: true })

      return (): void => elem.removeEventListener('scroll', debounce(func, 100))
    }
  }, [])
}

export default useScrollRestoration
